module.exports = Mustache;


//////////////////
// WEBPACK FOOTER
// external "Mustache"
// module id = 471
// module chunks = 2